"use strict";

angular.module("internal.exams").controller("InternalExamPermissionExaminers", ['$scope',
    'EXExaminers',
    'LicenseCategoryLevels',
    'Permissions',
    '$uibModal',
    function ($scope, EXExaminers, LicenseCategoryLevels, Permissions, $uibModal) {
        $scope.certs = [];

        LicenseCategoryLevels.get({ entity_id: '5384A3C9-A244-41CC-92C1-6423E4561B83' }).then(function (licenseCategoryLevels) {
            $scope.license_category_levels = licenseCategoryLevels;
            for (var x in licenseCategoryLevels) {
                var format = {
                    name: licenseCategoryLevels[x].combined_name, id: licenseCategoryLevels[x].id
                };
                $scope.certs.push(format);
            }
        });

        $scope.remove = function (id) {
            $uibModal.open({
                animation: true,
                templateUrl: 'templates/confirm/confirm.html',
                controller: 'ConfirmModalController',
                resolve: {
                    message: function () {
                        return "Are you sure you want to remove this user as an exam examiner?  This will remove the exam examiner from all the exams.";
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    EXExaminers.delete(id).then(function () {
                        $scope.refresh = new Date();
                    })
                }
            })
        }

        $scope.openAddModal = function () {
            $uibModal.open({
                animation: true,
                templateUrl: paths.app + 'exams/components/exam-permission-examiners/exam-permission-examiners-modal.html',
                controller: 'InternalExamPermissionExaminersModal',
                size: 'xl',
                resolve: {
                }
            }).result.then(function () {
                $scope.refresh = new Date();
            }, function () {
                $scope.refresh = new Date();
            });  
        }

        $scope.selectedColumns = [
            {
                label: 'Name',
                field: 'fullName'
            },
            {
                label: 'Username',
                field: 'userName'
            },
            {
                label: 'Email',
                field: 'email'
            }
        ];

        Permissions.delete('internal.exams.administrative.examiners').then(function (access) {
            if (access) {
                $scope.selectedColumns.push({
                    label: 'Remove',
                    html: '<hlp-icon classes="delete" name="remove" ng-click="$parent.$parent.$parent.$parent.$parent.remove($parent.$parent.$parent.record.id)"></hlp-icon>',
                    type: 'empty'
                });
            }
            else {
                $scope.selectedColumns.push({
                    label: 'Remove',
                    type: 'empty'
                });
            }
        });

        $scope.selectedFilters = [
            {
                name: 'All Personnel Types',
                field: 'internal',
                options: [
                    { name: 'External', id: false },
                    { name: 'Internal', id: true }
                ]
            },
            {
                name: 'Current Certification',
                field: 'currentCertificationLevelIdsString',
                options: $scope.certs,
                contains: true
            }
        ];
    }])
    ;